import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'loading-indicator',
    templateUrl: 'loading-indicator.component.html',
    styles: [`
      .loda-spinner {
        display: inline-block;
        width: 64px;
        height: 64px;
        line-height: 0;
      }
      .loda-spinner svg {
        width: 100%;
        height: 100%;
        animation: loda-spinner-rotate 1.6s linear infinite;
      }
      .loda-spinner__track {
        fill: none;
        stroke: rgba(13, 110, 253, 0.12);
        stroke-width: 4;
      }
      .loda-spinner__arc {
        fill: none;
        stroke: #0d6efd;
        stroke-width: 4;
        stroke-linecap: round;
        stroke-dasharray: 126;
        stroke-dashoffset: 126;
        transform-origin: center;
        animation: loda-spinner-dash 1.4s ease-in-out infinite;
      }
      @keyframes loda-spinner-rotate {
        100% { transform: rotate(360deg); }
      }
      @keyframes loda-spinner-dash {
        0% {
          stroke-dashoffset: 126;
          transform: rotate(0deg);
        }
        50% {
          stroke-dashoffset: 40;
          transform: rotate(90deg);
        }
        100% {
          stroke-dashoffset: 126;
          transform: rotate(360deg);
        }
      }
    `],
    standalone: false
})
export class LoadingIndicatorComponent implements OnInit {

  @Input()
  heading: string = '';

  @Input()
  message1: string = '';

  @Input()
  message2: string = '';

  @Input()
  showImage: boolean = true;

  constructor() { }

  ngOnInit() { }
}
